import * as yup from "yup";
import { Length, Max, Min, Validation } from "../../utils/Validation.utils";
export const PostalCodeInitialValues = {
    postalCode: undefined,
    city: "",
    stateName: "",
    latitude: 0,
    longitude: 0,
    countyName: null,
    timezone: null
};
export const PostalCodeSchema = yup.object().shape({
    postalCode: yup
        .string()
        .length(Length.PostalCode, Validation.Length)
        .required(Validation.Required),
    city: yup
        .string()
        .min(Min.City, Validation.Min)
        .max(Max.City, Validation.Max)
        .required("City is required"),
    stateName: yup.string().required(Validation.Required),
    latitude: yup.number().required(Validation.Required),
    longitude: yup.number().required(Validation.Required),
    countyName: yup
        .string()
        .min(Min.County, Validation.Min)
        .max(Max.County, Validation.Max)
        .nullable(),
    timezone: yup.string().nullable()
});
